export const play = () => (
  <path
    d="M7 3l14 9-14 9V3z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
